import * as actions from './actions'
import {Map, fromJS, Set} from 'immutable';


function reducer(
        state=Map({
            initialData: Map({
                isFetching: false,
                isFetched: 0
            }),
            login: Map({
                isFetching: false,
                id: Map(),
                token: Map(),
            }),
            signup: Map({
                isFetching: false,
            }),
            search: Map({
                isFetching: false,
                results: Map()
            }),
            localSettings: Map({
                notifySound: true,
                notifyWeb: true,
                mutedNotifications: Set()
            })
        }) ,action) {
    switch (action.type) {
        // ========= LOGIN REQUEST ===========
        case actions.USER_LOGIN_REQUEST:
            return state.setIn(['login', 'isFetching'], true)
        case actions.USER_LOGIN_SUCCESS:
            return state
                    .setIn(['login','isFetching'], false)
                    .setIn(['login','id'], fromJS(action.id))
                    .setIn(['login','token'], fromJS(action.token))
        case actions.USER_LOGIN_FAILURE:
            return state
                .setIn(['login','isFetching'], false)
        // ========INITIAL DATA REQUEST
        case actions.USER_FETCHING_INITIAL_DATA:
            return state.setIn(['initialData', 'isFetching'], true)
        case actions.USER_FETCHED_INITIAL_DATA_FAILURE:
            return state.setIn(['initialData', 'isFetching'], false)
                        .setIn(['initialData', 'isFetched'], 0)
        case actions.USER_FETCHED_INITIAL_DATA_SUCCESS:
            return state.setIn(['initialData', 'isFetching'], false)
                        .updateIn(['initialData', 'isFetched'], (fetched) => {
                            return ++fetched
                        })
                        .setIn(['login','token'], action.payload.token)

        // ======== SIGNUP REQUEST ===========
        case actions.USER_SIGNUP_REQUEST:
                return state.setIn(['signup','isFetching'], true)
        case actions.USER_SIGNUP_SUCCESS:
                return state.setIn(['signup','isFetching'], false)
        case actions.USER_SIGNUP_FAILURE:
                return state.setIn(['signup','isFetching'], false)

        // ============ USER SEARCH ============
        case actions.USER_FETCHING_SEARCH_RESULTS:
            return state.setIn(['search', 'isFetching'], true);
        case actions.USER_FETCHING_SEARCH_RESULTS_SUCCESS:
            return state
                .setIn(['search', 'isFetching'], false)
                .setIn(['search', 'results'], fromJS(action.results));
        // ================ NOTIFICATION (WEB AND SOUND) ==================
        case actions.USER_SOUND_ON:
            return state.setIn(['localSettings', 'notifySound'], true);
        case actions.USER_SOUND_OFF:
            return state.setIn(['localSettings', 'notifySound'], false);
        case actions.USER_WEB_NOTIFICATION_ON:
            return state.setIn(['localSettings', 'notifyWeb'], true);
        case actions.USER_WEB_NOTIFICATION_OFF:
            return state.setIn(['localSettings', 'notifyWeb'], false);
        case actions.USER_NOTIFY_ADD:
            return state.setIn(['localSettings', 'mutedNotifications'], state.getIn(['localSettings', 'mutedNotifications']).add(action.notificationType));
        case actions.USER_NOTIFY_REMOVE:
            return state.setIn(['localSettings', 'mutedNotifications'], state.getIn(['localSettings', 'mutedNotifications']).delete(action.notificationType));
        default:
            return state;
      }

}


export default reducer;



// WEBPACK FOOTER //
// src/model/User/reducer.js